import { Component } from '@angular/core';
import { XeroAccountInfo, XeroAccountItem } from 'sharedFeatures/newplan-win/models';
import { SubmenuDropdownPopupComponent, SubmenuItem } from 'sharedFeatures/submenu';
import { Utils } from 'sharedFeatures/utils';
import { SharedGuiSmallModule } from '../../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { ScrollComponent } from '../../../scroll/scrolldiv.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'pl-submenu-dropdown-popup',
    templateUrl: './pl-submenu-dropdown-popup.component.html',
    styleUrls: ['./pl-submenu-dropdown-popup.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, ScrollComponent, TranslateModule]
})
export class PLSubmenuDropdownPopupComponent extends SubmenuDropdownPopupComponent {

    current: any;

    acc: any;

    width = 340;

    ngAfterViewInit(): void {

        super.ngAfterViewInit();

        this.r.setStyle(this.getElDom().querySelector('.arrow-up'), 'left', `${this.getWidth() - 12}px`)
        
    }

    public initExt(itemDiv: HTMLElement, items: Array<SubmenuItem>, current: XeroAccountItem, acc: XeroAccountInfo, itemClickCallback: Function): void {

        super.init(itemDiv, items, itemClickCallback);

        this.current = current;
        this.acc = acc;

    }

    isMoveAllowed(item: SubmenuItem, itemSubHeading: string, acc?: XeroAccountInfo): boolean {

        if (!itemSubHeading) {

            if (this.current.key === item.title) return false;

            if (item.subHeadings && item.subHeadings.some((vl) => { return !Utils.isEmpty(vl); })) {
                return false;
            }

        }

        if (acc && acc.AccountSubHeading === itemSubHeading) return false;

        return true;

    }

    handlePLItemClick(item: SubmenuItem, itemSubHeading: string, acc?: XeroAccountInfo): void {

        if (!this.isMoveAllowed(item, itemSubHeading, acc)) return;

        // Pass item to parent component
        if (this.itemClickCallback)
            this.itemClickCallback(item.title, itemSubHeading);

        this.close();

    }

}